import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  paper: {
    width: '100%',
    height: '100%',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  chatBox: {
    width: '100%',
    flexGrow: 1,
    overflow: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/ChatPage/useStyles.js